// import { useState, useCallback, useEffect } from 'react';
// import { useAccount, useReadContract, useWriteContract, useWaitForTransactionReceipt, useWatchContractEvent } from 'wagmi';
// import { parseUnits } from 'viem';
// import { CONTRACTS } from '../config/contracts';

// export const useNFTPurchase = (tokenId, price, onPurchaseSuccess) => {
//   const { address, isConnected } = useAccount();
//   const [purchaseState, setPurchaseState] = useState('idle'); // idle, checking, approving, buying, confirming, success, error
//   const [error, setError] = useState(null);
//   const [currentTxHash, setCurrentTxHash] = useState(null);

//   const { writeContract: approve, data: approveHash, error: approveError } = useWriteContract();
//   const { writeContract: buy, data: buyHash, error: buyError } = useWriteContract();

//   // Wait for approval transaction
//   const {
//     isLoading: isApproving,
//     isSuccess: approvalSuccess,
//     isError: approvalTxError
//   } = useWaitForTransactionReceipt({
//     hash: approveHash,
//   });

//   // Wait for buy transaction
//   const {
//     isLoading: isBuying,
//     isSuccess: buyTxSuccess,
//     isError: buyTxError,
//     data: buyReceipt
//   } = useWaitForTransactionReceipt({
//     hash: buyHash,
//   });

//   // Read current allowance
//   const { data: currentAllowance, refetch: refetchAllowance } = useReadContract({
//     address: CONTRACTS.TOKEN.address,
//     abi: CONTRACTS.TOKEN.abi,
//     functionName: 'allowance',
//     args: address && isConnected ? [address, CONTRACTS.NFT.address] : undefined,
//     enabled: !!address && isConnected,
//   });

//   // Read NFT price from contract
//   const { data: contractPrice } = useReadContract({
//     address: CONTRACTS.NFT.address,
//     abi: CONTRACTS.NFT.abi,
//     functionName: 'price',
//     enabled: true,
//   });

//   // Listen for Purchased event (as backup - primary is now receipt processing)
//   useWatchContractEvent({
//     address: CONTRACTS.NFT.address,
//     abi: CONTRACTS.NFT.abi,
//     eventName: 'Purchased',
//     onLogs: (logs) => {
//       console.log('Received Purchased event logs:', logs);

//       logs.forEach((log) => {
//         const { buyer, tokenId: purchasedTokenId, pricePaid } = log.args;

//         console.log('Event details:', {
//           buyer: buyer?.toLowerCase(),
//           tokenId: purchasedTokenId?.toString(),
//           pricePaid: pricePaid?.toString(),
//           currentAddress: address?.toLowerCase(),
//           currentTokenId: tokenId?.toString(),
//           currentState: purchaseState
//         });

//         // Check if this event is for the current user and token
//         // Don't check purchaseState here as event might arrive late
//         if (
//           buyer?.toLowerCase() === address?.toLowerCase() &&
//           purchasedTokenId?.toString() === tokenId?.toString()
//         ) {
//           console.log('Purchase event matches - processing via event listener');

//           // Only process if not already processed
//           if (purchaseState === 'buying' || purchaseState === 'idle') {
//             setPurchaseState('confirming');
//             setCurrentTxHash(log.transactionHash);

//             if (onPurchaseSuccess) {
//               onPurchaseSuccess({
//                 tokenId: purchasedTokenId.toString(),
//                 transactionHash: log.transactionHash,
//                 buyer,
//                 pricePaid: pricePaid.toString(),
//               }).then(() => {
//                 setPurchaseState('success');
//                 setTimeout(() => {
//                   setPurchaseState('idle');
//                   setError(null);
//                 }, 3000);
//               }).catch((err) => {
//                 console.error('Backend confirmation failed:', err);
//                 setError('Purchase succeeded on blockchain but database update failed');
//                 setPurchaseState('error');
//               });
//             }
//           }
//         }
//       });
//     },
//   });

//   const handlePurchase = useCallback(async () => {
//     if (!isConnected || !address) {
//       setError('Please connect your wallet first');
//       setPurchaseState('error');

//       setTimeout(() => {
//         setPurchaseState('idle');
//         setError(null);
//       }, 5000);
//       return;
//     }

//     try {
//       setError(null);
//       setPurchaseState('checking');

//       // Use contract price or fallback to passed price
//       const priceToUse = contractPrice || parseUnits(price.toString(), 18);

//       // Check current allowance
//       await refetchAllowance();
//       const needsApproval = !currentAllowance || currentAllowance < priceToUse;

//       if (needsApproval) {
//         // Need to approve first
//         setPurchaseState('approving');
//         console.log('Approving token spend...', {
//           tokenAddress: CONTRACTS.TOKEN.address,
//           spender: CONTRACTS.NFT.address,
//           amount: priceToUse.toString(),
//         });

//         try {
//           approve({
//             address: CONTRACTS.TOKEN.address,
//             abi: CONTRACTS.TOKEN.abi,
//             functionName: 'approve',
//             args: [CONTRACTS.NFT.address, priceToUse],
//           });
//         } catch (approveErr) {
//           console.error('Approve call failed:', approveErr);
//           setError('Failed to send approval transaction');
//           setPurchaseState('error');

//           setTimeout(() => {
//             setPurchaseState('idle');
//             setError(null);
//           }, 5000);
//         }
//       } else {
//         executeBuy();
//       }
//     } catch (err) {
//       console.error('Purchase error:', err);
//       setError(err.message || 'Transaction failed');
//       setPurchaseState('error');

//       setTimeout(() => {
//         setPurchaseState('idle');
//         setError(null);
//       }, 5000);
//     }
//   }, [isConnected, address, contractPrice, price, currentAllowance, refetchAllowance, approve, tokenId]);

//   const executeBuy = useCallback(() => {
//     setPurchaseState('buying');
//     console.log('Executing buy transaction...', {
//       nftAddress: CONTRACTS.NFT.address,
//       tokenId,
//     });

//     try {
//       buy({
//         address: CONTRACTS.NFT.address,
//         abi: CONTRACTS.NFT.abi,
//         functionName: 'buy',
//         args: [tokenId],
//       });
//     } catch (buyErr) {
//       console.error('Buy call failed:', buyErr);
//       setError('Failed to send purchase transaction');
//       setPurchaseState('error');

//       setTimeout(() => {
//         setPurchaseState('idle');
//         setError(null);
//       }, 5000);
//     }
//   }, [buy, tokenId]);

//   // Auto-trigger buy after approval succeeds
//   useEffect(() => {
//     if (approvalSuccess && purchaseState === 'approving') {
//       executeBuy();
//     }
//   }, [approvalSuccess, purchaseState, executeBuy]);

//   // Handle approval errors (user rejection or transaction failure)
//   useEffect(() => {
//     if (approveError && purchaseState === 'approving') {
//       console.error('Approval error:', approveError);
//       const errorMessage = approveError.message || 'Approval failed';

//       // Check if user rejected
//       if (errorMessage.includes('User rejected') || errorMessage.includes('user rejected')) {
//         setError('Transaction rejected by user');
//       } else {
//         setError(errorMessage);
//       }

//       setPurchaseState('error');

//       // Reset to idle after 5 seconds
//       setTimeout(() => {
//         setPurchaseState('idle');
//         setError(null);
//       }, 5000);
//     }
//   }, [approveError, purchaseState]);

//   // Handle approval transaction errors (on-chain failure)
//   useEffect(() => {
//     if (approvalTxError && purchaseState === 'approving') {
//       console.error('Approval transaction failed on blockchain');
//       setError('Approval transaction failed on blockchain');
//       setPurchaseState('error');

//       setTimeout(() => {
//         setPurchaseState('idle');
//         setError(null);
//       }, 5000);
//     }
//   }, [approvalTxError, purchaseState]);

//   // Handle buy errors (user rejection or transaction failure)
//   useEffect(() => {
//     if (buyError && purchaseState === 'buying') {
//       console.error('Buy error:', buyError);
//       const errorMessage = buyError.message || 'Purchase failed';

//       // Check if user rejected
//       if (errorMessage.includes('User rejected') || errorMessage.includes('user rejected')) {
//         setError('Transaction rejected by user');
//       } else {
//         setError(errorMessage);
//       }

//       setPurchaseState('error');

//       // Reset to idle after 5 seconds
//       setTimeout(() => {
//         setPurchaseState('idle');
//         setError(null);
//       }, 5000);
//     }
//   }, [buyError, purchaseState]);

//   // Handle buy transaction errors (on-chain failure)
//   useEffect(() => {
//     if (buyTxError && purchaseState === 'buying') {
//       console.error('Buy transaction failed on blockchain');
//       setError('Purchase transaction failed on blockchain');
//       setPurchaseState('error');

//       setTimeout(() => {
//         setPurchaseState('idle');
//         setError(null);
//       }, 5000);
//     }
//   }, [buyTxError, purchaseState]);

//   // Fallback: Process transaction receipt directly if event not caught
//   useEffect(() => {
//     const processPurchaseReceipt = async () => {
//       if (buyTxSuccess && buyReceipt && purchaseState === 'buying') {
//         console.log('Buy transaction succeeded, processing receipt...', buyReceipt);

//         try {
//           // Parse logs to find Purchased event
//           const { ethers } = await import('ethers');
//           const iface = new ethers.Interface(CONTRACTS.NFT.abi);

//           let purchaseEvent = null;

//           for (const log of buyReceipt.logs) {
//             try {
//               const parsed = iface.parseLog({
//                 topics: log.topics,
//                 data: log.data
//               });

//               if (parsed && parsed.name === 'Purchased') {
//                 const eventTokenId = parsed.args.tokenId.toString();
//                 const eventBuyer = parsed.args.buyer.toLowerCase();

//                 console.log('Found Purchased event in receipt:', {
//                   tokenId: eventTokenId,
//                   buyer: eventBuyer,
//                   pricePaid: parsed.args.pricePaid.toString()
//                 });

//                 if (eventTokenId === tokenId?.toString() && eventBuyer === address?.toLowerCase()) {
//                   purchaseEvent = {
//                     tokenId: eventTokenId,
//                     transactionHash: buyReceipt.transactionHash,
//                     buyer: eventBuyer,
//                     pricePaid: parsed.args.pricePaid.toString()
//                   };
//                   break;
//                 }
//               }
//             } catch (parseError) {
//               // Skip logs that don't match
//               continue;
//             }
//           }

//           if (purchaseEvent) {
//             console.log('Processing purchase from receipt:', purchaseEvent);
//             setPurchaseState('confirming');
//             setCurrentTxHash(purchaseEvent.transactionHash);

//             if (onPurchaseSuccess) {
//               try {
//                 await onPurchaseSuccess(purchaseEvent);
//                 setPurchaseState('success');
//                 setTimeout(() => {
//                   setPurchaseState('idle');
//                   setError(null);
//                 }, 3000);
//               } catch (err) {
//                 console.error('Backend confirmation failed:', err);
//                 setError('Purchase succeeded on blockchain but database update failed');
//                 setPurchaseState('error');
//               }
//             }
//           } else {
//             console.error('No Purchased event found in receipt');
//             setError('Transaction succeeded but event not found. Please contact support.');
//             setPurchaseState('error');
//           }
//         } catch (err) {
//           console.error('Error processing receipt:', err);
//           setError('Failed to process transaction receipt');
//           setPurchaseState('error');
//         }
//       }
//     };

//     processPurchaseReceipt();
//   }, [buyTxSuccess, buyReceipt, purchaseState, tokenId, address, onPurchaseSuccess]);

//   // Manual reset function
//   const resetPurchase = useCallback(() => {
//     setPurchaseState('idle');
//     setError(null);
//     setCurrentTxHash(null);
//   }, []);

//   return {
//     purchaseState,
//     error,
//     isConnected,
//     address,
//     handlePurchase,
//     resetPurchase,
//     currentTxHash,
//     isLoading: purchaseState === 'checking' || purchaseState === 'approving' || purchaseState === 'buying' || purchaseState === 'confirming',
//     isApproving,
//     isBuying,
//   };
// };

import { useState, useCallback, useEffect } from 'react';
import { useAccount, useReadContract, useWriteContract, useWaitForTransactionReceipt, useWatchContractEvent } from 'wagmi';
import { parseUnits } from 'viem';
import { CONTRACTS } from '../config/contracts';

export const useNFTPurchase = (tokenId, price, onPurchaseSuccess) => {
  const { address, isConnected } = useAccount();
  const [purchaseState, setPurchaseState] = useState('idle'); // idle, checking, approving, buying, confirming, success, error
  const [error, setError] = useState(null);
  const [currentTxHash, setCurrentTxHash] = useState(null);

  const { writeContract: approve, data: approveHash, error: approveError } = useWriteContract();
  const { writeContract: buy, data: buyHash, error: buyError } = useWriteContract();

  const {
    isLoading: isApproving,
    isSuccess: approvalSuccess,
    isError: approvalTxError
  } = useWaitForTransactionReceipt({
    hash: approveHash,
  });

  const {
    isLoading: isBuying,
    isSuccess: buyTxSuccess,
    isError: buyTxError,
    data: buyReceipt
  } = useWaitForTransactionReceipt({
    hash: buyHash,
  });

  const { data: currentAllowance, refetch: refetchAllowance } = useReadContract({
    address: CONTRACTS.TOKEN.address,
    abi: CONTRACTS.TOKEN.abi,
    functionName: 'allowance',
    args: address && isConnected ? [address, CONTRACTS.NFT.address] : undefined,
    enabled: !!address && isConnected,
  });


  const { data: contractPrice } = useReadContract({
    address: CONTRACTS.NFT.address,
    abi: CONTRACTS.NFT.abi,
    functionName: 'price',
    enabled: true,
  });

  const { data: tokenBalance } = useReadContract({
  address: CONTRACTS.TOKEN.address,
  abi: CONTRACTS.TOKEN.abi,
  functionName: 'balanceOf',
  args: address && isConnected ? [address] : undefined,
  enabled: !!address && isConnected,
});


  useWatchContractEvent({
    address: CONTRACTS.NFT.address,
    abi: CONTRACTS.NFT.abi,
    eventName: 'Purchased',
    onLogs: (logs) => {
      console.log('Received Purchased event logs:', logs);

      logs.forEach((log) => {
        const { buyer, tokenId: purchasedTokenId, pricePaid } = log.args;

        console.log('Event details:', {
          buyer: buyer?.toLowerCase(),
          tokenId: purchasedTokenId?.toString(),
          pricePaid: pricePaid?.toString(),
          currentAddress: address?.toLowerCase(),
          currentTokenId: tokenId?.toString(),
          currentState: purchaseState
        });

      
        if (
          buyer?.toLowerCase() === address?.toLowerCase() &&
          purchasedTokenId?.toString() === tokenId?.toString()
        ) {
          console.log('Purchase event matches - processing via event listener');

          if (purchaseState === 'buying' || purchaseState === 'idle') {
            setPurchaseState('confirming');
            setCurrentTxHash(log.transactionHash);

            if (onPurchaseSuccess) {
              onPurchaseSuccess({
                tokenId: purchasedTokenId.toString(),
                transactionHash: log.transactionHash,
                buyer,
                pricePaid: pricePaid.toString(),
              }).then(() => {
                setPurchaseState('success');
                setTimeout(() => {
                  setPurchaseState('idle');
                  setError(null);
                }, 3000);
              }).catch((err) => {
                console.error('Backend confirmation failed:', err);
                setError('Purchase succeeded on blockchain but database update failed');
                setPurchaseState('error');
              });
            }
          }
        }
      });
    },
  });

  const handlePurchase = useCallback(async () => {
    if (!isConnected || !address) {
      setError('Please connect your wallet first');
      setPurchaseState('error');

      setTimeout(() => {
        setPurchaseState('idle');
        setError(null);
      }, 5000);
      return;
    }

    try {
      setError(null);
      setPurchaseState('checking');

      const priceToUse = contractPrice || parseUnits(price.toString(), 18);

      if (!tokenBalance || tokenBalance < priceToUse) {
      setError('Insufficient token balance to complete purchase');
      setPurchaseState('error');
      setTimeout(() => {
        setPurchaseState('idle');
        setError(null);
      }, 5000);
      return;
    }

      await refetchAllowance();
      const needsApproval = !currentAllowance || currentAllowance < priceToUse;

      if (needsApproval) {
        setPurchaseState('approving');
        console.log('Approving token spend...', {
          tokenAddress: CONTRACTS.TOKEN.address,
          spender: CONTRACTS.NFT.address,
          amount: priceToUse.toString(),
        });

        try {
          approve({
            address: CONTRACTS.TOKEN.address,
            abi: CONTRACTS.TOKEN.abi,
            functionName: 'approve',
            args: [CONTRACTS.NFT.address, priceToUse],
          });
        } catch (approveErr) {
          console.error('Approve call failed:', approveErr);
          setError('Failed to send approval transaction');
          setPurchaseState('error');

          setTimeout(() => {
            setPurchaseState('idle');
            setError(null);
          }, 5000);
        }
      } else {
        executeBuy();
      }
    } catch (err) {
      console.error('Purchase error:', err);
      setError(err.message || 'Transaction failed');
      setPurchaseState('error');

      setTimeout(() => {
        setPurchaseState('idle');
        setError(null);
      }, 5000);
    }
  }, [isConnected, address, contractPrice, price, currentAllowance, refetchAllowance, approve, tokenId]);

  const executeBuy = useCallback(() => {
    setPurchaseState('buying');
    console.log('Executing buy transaction...', {
      nftAddress: CONTRACTS.NFT.address,
      tokenId,
    });

    try {
      buy({
        address: CONTRACTS.NFT.address,
        abi: CONTRACTS.NFT.abi,
        functionName: 'buy',
        args: [tokenId],
      });
    } catch (buyErr) {
      console.error('Buy call failed:', buyErr);
      setError('Failed to send purchase transaction');
      setPurchaseState('error');

      setTimeout(() => {
        setPurchaseState('idle');
        setError(null);
      }, 5000);
    }
  }, [buy, tokenId]);

  useEffect(() => {
    if (approvalSuccess && purchaseState === 'approving') {
      executeBuy();
    }
  }, [approvalSuccess, purchaseState, executeBuy]);

  useEffect(() => {
    if (approveError && purchaseState === 'approving') {
      console.error('Approval error:', approveError);
      const errorMessage = approveError.message || 'Approval failed';

      if (errorMessage.includes('User rejected') || errorMessage.includes('user rejected')) {
        setError('Transaction rejected by user');
      } else {
        setError(errorMessage);
      }

      setPurchaseState('error');

      setTimeout(() => {
        setPurchaseState('idle');
        setError(null);
      }, 5000);
    }
  }, [approveError, purchaseState]);

  useEffect(() => {
    if (approvalTxError && purchaseState === 'approving') {
      console.error('Approval transaction failed on blockchain');
      setError('Approval transaction failed on blockchain');
      setPurchaseState('error');

      setTimeout(() => {
        setPurchaseState('idle');
        setError(null);
      }, 5000);
    }
  }, [approvalTxError, purchaseState]);

  useEffect(() => {
    if (buyError && purchaseState === 'buying') {
      console.error('Buy error:', buyError);
      const errorMessage = buyError.message || 'Purchase failed';

      // Check if user rejected
      if (errorMessage.includes('User rejected') || errorMessage.includes('user rejected')) {
        setError('Transaction rejected by user');
      } else {
        setError(errorMessage);
      }

      setPurchaseState('error');

      // Reset to idle after 5 seconds
      setTimeout(() => {
        setPurchaseState('idle');
        setError(null);
      }, 5000);
    }
  }, [buyError, purchaseState]);

  useEffect(() => {
    if (buyTxError && purchaseState === 'buying') {
      console.error('Buy transaction failed on blockchain');
      setError('Purchase transaction failed on blockchain');
      setPurchaseState('error');

      setTimeout(() => {
        setPurchaseState('idle');
        setError(null);
      }, 5000);
    }
  }, [buyTxError, purchaseState]);

  // Fallback: Process transaction receipt directly if event not caught
  useEffect(() => {
    const processPurchaseReceipt = async () => {
      if (buyTxSuccess && buyReceipt && purchaseState === 'buying') {
        console.log('Buy transaction succeeded, processing receipt...', buyReceipt);

        try {
          // Parse logs to find Purchased event
          const { ethers } = await import('ethers');
          const iface = new ethers.Interface(CONTRACTS.NFT.abi);

          let purchaseEvent = null;

          for (const log of buyReceipt.logs) {
            try {
              const parsed = iface.parseLog({
                topics: log.topics,
                data: log.data
              });

              if (parsed && parsed.name === 'Purchased') {
                const eventTokenId = parsed.args.tokenId.toString();
                const eventBuyer = parsed.args.buyer.toLowerCase();

                console.log('Found Purchased event in receipt:', {
                  tokenId: eventTokenId,
                  buyer: eventBuyer,
                  pricePaid: parsed.args.pricePaid.toString()
                });

                if (eventTokenId === tokenId?.toString() && eventBuyer === address?.toLowerCase()) {
                  purchaseEvent = {
                    tokenId: eventTokenId,
                    transactionHash: buyReceipt.transactionHash,
                    buyer: eventBuyer,
                    pricePaid: parsed.args.pricePaid.toString()
                  };
                  break;
                }
              }
            } catch (parseError) {
              // Skip logs that don't match
              continue;
            }
          }

          if (purchaseEvent) {
            console.log('Processing purchase from receipt:', purchaseEvent);
            setPurchaseState('confirming');
            setCurrentTxHash(purchaseEvent.transactionHash);

            if (onPurchaseSuccess) {
              try {
                await onPurchaseSuccess(purchaseEvent);
                setPurchaseState('success');
                setTimeout(() => {
                  setPurchaseState('idle');
                  setError(null);
                }, 3000);
              } catch (err) {
                console.error('Backend confirmation failed:', err);
                setError('Purchase succeeded on blockchain but database update failed');
                setPurchaseState('error');
              }
            }
          } else {
            console.error('No Purchased event found in receipt');
            setError('Transaction succeeded but event not found. Please contact support.');
            setPurchaseState('error');
          }
        } catch (err) {
          console.error('Error processing receipt:', err);
          setError('Failed to process transaction receipt');
          setPurchaseState('error');
        }
      }
    };

    processPurchaseReceipt();
  }, [buyTxSuccess, buyReceipt, purchaseState, tokenId, address, onPurchaseSuccess]);

  // Manual reset function
  const resetPurchase = useCallback(() => {
    setPurchaseState('idle');
    setError(null);
    setCurrentTxHash(null);
  }, []);

  return {
    purchaseState,
    error,
    isConnected,
    address,
    handlePurchase,
    resetPurchase,
    currentTxHash,
    isLoading: purchaseState === 'checking' || purchaseState === 'approving' || purchaseState === 'buying' || purchaseState === 'confirming',
    isApproving,
    isBuying,
  };
};
